import TickerItems from "../TickerItems";
import { SHOW_STANDINGS, SHOW_RESULTS } from "../../constants-ticker";
import { createLeagueItem, createStandingItem, createStandingPhaseItem, firstNonEmpty, formatTeamMatches, toCollection, isCurrentDateInRange, getPhaseName } from "./tickerSportUtils";

/** Contenido FOOT: renderiza sólo el soccerStage activo según startDate/endDate. */
export default function SoccerTickerContent({ league, standing, results, upcoming, renderStandingOnly = false }) {
  const source = firstNonEmpty(standing?.soccerStages, standing?.soccer_stage);
  const stages = toCollection(source, ["division"]);
  const activeStageIndex = stages.findIndex((stage) => isCurrentDateInRange(stage?.startDate, stage?.endDate));
  const activeStage = activeStageIndex >= 0 ? stages[activeStageIndex] : null;
  const divisions = toCollection(activeStage?.division, ["ranking"]);
  const standings = SHOW_STANDINGS ? divisions.flatMap((division, divisionIndex) => {
    const ranking = toCollection(division?.ranking, ["rank", "contestantName", "contestantShortName"]);

    if (!ranking.length) return [];

    return [
      createStandingPhaseItem(getPhaseName(activeStage, division, activeStageIndex, divisionIndex)),
      ...ranking.map((team, index) => createStandingItem({
        entry: team,
        fallbackRank: index + 1,
        image: team?.image || "",
        name: team?.contestantShortName || team?.contestantName || team?.name || "Equipo",
        points: team?.points,
      })),
    ];
  }) : [];

  if (renderStandingOnly) return <TickerItems items={standings} />;
  const resultMatches = SHOW_RESULTS ? formatTeamMatches(results, league?.name, "", "Resultado", true) : [];
  return <TickerItems leagueItem={createLeagueItem(league)} standings={standings} results={resultMatches} upcoming={formatTeamMatches(upcoming, league?.name, "", "Próximo", false)} />;
}